import React, { useEffect, useState } from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';

export default function ExportButton({
  data,
  filename = 'export',
  headers = [],
  columns = [],
  className = '',
  setIsExport
}) {

  const [isExporting, setIsExporting] = useState(false);

  const handleClick = () => {
    setIsExporting(true);
    setIsExport(1)

  }

  const exportToCSV = () => {

    if (data.length === 0) {
      toast.error('Data yoxdur')
      return
    }

    setTimeout(() => {
      try {
        // Prepare CSV content
        let csvContent = '';

        // Determine headers to use
        let csvHeaders = [];
        let columnKeys = [];
        
        if (columns.length > 0) {
          // Use columns prop (preferred)
          csvHeaders = columns.map(col => col.label || col.key);
          columnKeys = columns.map(col => col.key);
        } else if (headers.length > 0) {
          // Fallback to headers prop
          csvHeaders = headers;
          columnKeys = Object.keys(data[0] || {});
        } else {
          // Auto-generate from first data row
          columnKeys = Object.keys(data[0] || {});
          csvHeaders = columnKeys;
        }

        // Add headers to CSV
        if (csvHeaders.length > 0) {
          csvContent += csvHeaders.join(',') + '\n';
        }

        // Add data rows
        data.forEach(row => {
          const values = columnKeys.map(key => {
            const value = row[key];
            // Handle values that contain commas or quotes
            if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
              return '"' + value.replace(/"/g, '""') + '"';
            }
            return value || '';
          });
          csvContent += values.join(',') + '\n';
        });

        // Create and download file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        setIsExporting(false);
      } catch (error) {
        console.error('Export error:', error);
        alert('Export zamanı xəta yarandı');
        setIsExporting(false);
      } finally {
        setIsExport(0)
      }
    }, 500);
  };

  useEffect(() => {
    if (isExporting) {
      exportToCSV()
    }
  }, [data])

  return (
    <button
      onClick={handleClick}
      disabled={isExporting}
      className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ${className}`}
    >
      {isExporting ? (
        <>
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Export edilir...
        </>
      ) : (
        <>
          <ArrowDownTrayIcon className="-ml-1 mr-2 h-4 w-4" />
          Export CSV
        </>
      )}
    </button>
  );
} 